// extracted by mini-css-extract-plugin
export default {"budgetColumn":"styles_budgetColumn__brt-Q","budgetColumn__editBudget":"styles_budgetColumn__editBudget__L-h0r"};